module.exports = __webpack_public_path__ + "img/convenio_acmma.0118dd99.jpg";